import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

var Drawer = function Drawer() {
  var _useState = useState(false),
      drawerOpen = _useState[0],
      setDrawerOpen = _useState[1];

  var openDrawer = function openDrawer() {
    setDrawerOpen(true);
  };

  var closeDrawer = function closeDrawer() {
    setDrawerOpen(false);
  };

  var DrawerPortal = function DrawerPortal(_ref) {
    var children = _ref.children;
    var ref = useRef();

    var _useState2 = useState(false),
        mounted = _useState2[0],
        setMounted = _useState2[1];

    useEffect(function () {
      setMounted(true);

      if (document) {
        var dom = document.querySelector('#local-drawer');
        ref.current = dom;
      }
    }, []);

    if (ref.current && mounted && drawerOpen) {
      return /*#__PURE__*/createPortal(children, ref.current);
    }

    return null;
  };

  return {
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    DrawerPortal: DrawerPortal
  };
};

export default Drawer;